import {NgModule} from "@angular/core";
import {LocalisationModalComponent} from "./localisation-modal/localisation-modal.component";
import {SharedModule} from "../shared/shared.module";
import {LocalisationIndicatorComponent} from "./localisation-indicator/localisation-indicator.component";
import {LocalisationAutoCompleteControlComponent} from "./localisation-controls/localisation-autocomplete-control/localisation-autocomplete-control.component";
import {LocalisationOutletSelectionComponent} from "./localisation-outlet-selection/localisation-outlet-selection.component";
import {LocalisationOutletSelectionAutocompleteComponent} from "./localisation-outlet-selection/localisation-outlet-selection-autocomplete.component";
import {LocalisationPageComponent} from "./localisation-page/localisation-page.component";
import {LocalisationChromeControlComponent} from "./localisation-controls/localisation-chrome-control/localisation-chrome-control.component";

@NgModule({
    declarations: [
        LocalisationAutoCompleteControlComponent,
        LocalisationChromeControlComponent,
        LocalisationIndicatorComponent,
        LocalisationOutletSelectionComponent,
        LocalisationOutletSelectionAutocompleteComponent,
        LocalisationModalComponent,
        LocalisationPageComponent
    ],
    exports: [
        LocalisationChromeControlComponent,
        LocalisationIndicatorComponent,
        LocalisationOutletSelectionComponent,
        LocalisationOutletSelectionAutocompleteComponent,
        LocalisationModalComponent,
        LocalisationPageComponent
    ],
    imports: [
        SharedModule
    ]
})
export class LocalisationModule {
}
